if (!customElements.get("product-form")) {
    customElements.define(
        "product-form",
        class ProductForm extends HTMLElement {
            constructor() {
                super();

                this.form = this.querySelector("form");
                this.form.querySelector("[name=id]").disabled = false;
                this.form.addEventListener(
                    "submit",
                    this.onSubmitHandler.bind(this)
                );
                this.cartDrawer = document.querySelector("cart-drawer");
                this.submitButton = this.querySelector('[type="submit"]');
                this.quantityInput = this.querySelector('[name="quantity"]');
            }

            onSubmitHandler(evt) {
                evt.preventDefault();

                if(debug) {
                    console.log("the blank has been submit");
                }

                if (this.submitButton.getAttribute("aria-disabled") === "true")
                    return;

                this.handleErrorMessage();

                this.submitButton.setAttribute("aria-disabled", true);
                this.submitButton.classList.add("loading");
                this.querySelector(
                    ".loading-overlay__spinner"
                ).classList.remove("hidden");

                const config = fetchConfig("javascript");
                config.headers["X-Requested-With"] = "XMLHttpRequest";
                delete config.headers["Content-Type"];

                //quantity
                const quantity = this.quantityInput ? parseInt(this.quantityInput.value, 10) : 1;

                const formData = new FormData(this.form);

                if(debug) {
                    console.log('this is the formData: ', formData);
                }

                // The drawer re-fetches its own section after the add (CartDrawer.updateCartDisplay),
                // so no `sections` payload is requested here.
                config.body = formData;

                formData.set("quantity", quantity);

                fetch(`${routes.cart_add_url}`, config)
                    .then((response) => response.json())
                    .then((response) => {
                        if (response.status) {
                            this.handleErrorMessage(response.description);

                            this.submitButton.setAttribute(
                                "aria-disabled",
                                true
                            );
                            this.submitButton
                                .querySelector("span")
                                .classList.add("hidden");
                            const soldOutMessage = this.querySelector(".sold-out-message");
                            if (soldOutMessage) soldOutMessage.classList.remove("hidden");
                            this.error = true;
                            return;
                        }

                        this.error = false;

                        if (this.cartDrawer) {
                            this.cartDrawer.updateCartDisplay(response);
                            this.cartDrawer.open(window.accessibilityStrings.cartItemAdded);
                        }

                        // Lets containers (e.g. cart drawer recommendations) know which form added an item.
                        this.dispatchEvent(
                            new CustomEvent("product-form:added", {
                                bubbles: true,
                                detail: { response },
                            })
                        );

                        document.dispatchEvent(new Event("postCartAction"));

                    })
                    .catch((e) => {
                        if(e) {console.error(e);}
                    })
                    .finally(() => {
                        this.submitButton.classList.remove("loading");

                        if (!this.error)
                            this.submitButton.removeAttribute("aria-disabled");
                        this.querySelector(
                            ".loading-overlay__spinner"
                        ).classList.add("hidden");
                        document.dispatchEvent(new Event("postCartAction"));
                    });
            }

            handleErrorMessage(errorMessage = false) {
                this.errorMessageWrapper =
                    this.errorMessageWrapper ||
                    this.querySelector(".product-form__error-message-wrapper");
                if (!this.errorMessageWrapper) return;
                this.errorMessage =
                    this.errorMessage ||
                    this.errorMessageWrapper.querySelector(
                        ".product-form__error-message"
                    );

                this.errorMessageWrapper.toggleAttribute(
                    "hidden",
                    !errorMessage
                );

                if (errorMessage) {
                    this.errorMessage.textContent = errorMessage;
                }
            }
        }
    );
}